'use client';

import { c as _c } from "react/compiler-runtime";
import { Input } from '@common/components';
import { FOCUS_RING } from '@common/components/interaction';
import { SvgMagnifyingGlass } from '@common/icon';
import { cn } from '@core/utils';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { UnauthQueryOptions } from '@/api';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
const ALL_TAB_LABEL = '전체';
interface RegionFinderDialogProps {
  opened: boolean;
  onClose: () => void;
}
export const RegionFinderDialog = t0 => {
  const $ = _c(63);
  const {
    opened,
    onClose
  } = t0;
  const router = useCustomRouter();
  const [selectedParentId, setSelectedParentId] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = keyword => {
      setSearchKeyword(keyword);
      setSelectedParentId(null);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleSearchChange = t1;
  let t2;
  if ($[1] !== onClose) {
    t2 = () => {
      setSelectedParentId(null);
      setSearchKeyword("");
      onClose();
    };
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleClose = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = UnauthQueryOptions["get:/wello/v2/allows/home-love-gov-code/parent"]();
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== opened) {
    t4 = {
      ...t3,
      select: _temp,
      enabled: opened
    };
    $[4] = opened;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    data: provinces
  } = useQuery(t4);
  let t5;
  if ($[6] !== selectedParentId) {
    t5 = UnauthQueryOptions["get:/wello/v2/allows/home-love-gov-code/child"]({
      query: {
        parentHomeLoveGovCodeId: selectedParentId ?? undefined
      }
    });
    $[6] = selectedParentId;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== opened || $[9] !== t5) {
    t6 = {
      ...t5,
      select: _temp2,
      enabled: opened
    };
    $[8] = opened;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const {
    data: districts,
    isPending
  } = useQuery(t6);
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t7;
  let t8;
  let t9;
  if ($[11] !== districts || $[12] !== handleClose || $[13] !== isPending || $[14] !== opened || $[15] !== provinces || $[16] !== router || $[17] !== searchKeyword || $[18] !== selectedParentId) {
    const keyword_0 = searchKeyword.trim();
    const rows = (districts ?? []).filter(district => !keyword_0 || district.fullName.includes(keyword_0) || district.value.includes(keyword_0)).map(_temp3);
    let t19;
    if ($[32] !== handleClose || $[33] !== router) {
      t19 = id => {
        handleClose();
        router.push(DONATION_ROUTES.HOMETOWNS_DETAIL.pathname({
          id
        }));
      };
      $[32] = handleClose;
      $[33] = router;
      $[34] = t19;
    } else {
      t19 = $[34];
    }
    const handleSelectRegion = t19;
    T0 = ResponsiveDialog;
    t13 = true;
    t14 = true;
    t15 = "\uC9C0\uC5ED\uCC3E\uAE30";
    t16 = opened;
    t17 = handleClose;
    t18 = "\uC9C0\uC5ED\uCC3E\uAE30";
    t11 = "flex h-full flex-col xl:h-[70dvh]";
    let t20;
    let t21;
    let t22;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = <SvgMagnifyingGlass className="size-20 text-Gray-550" />;
      t21 = event => handleSearchChange(event.target.value);
      t22 = () => handleSearchChange("");
      $[35] = t20;
      $[36] = t21;
      $[37] = t22;
    } else {
      t20 = $[35];
      t21 = $[36];
      t22 = $[37];
    }
    if ($[38] !== searchKeyword) {
      t12 = <div className="px-20 pb-16"><Input type="search" placeholder={"\uC9C0\uC5ED\uC744 \uCC3E\uC544\uBCF4\uC138\uC694"} value={searchKeyword} leftContent={t20} onChange={t21} onClear={t22} /></div>;
      $[38] = searchKeyword;
      $[39] = t12;
    } else {
      t12 = $[39];
    }
    t9 = "flex min-h-0 flex-1 border-t border-Gray-200";
    if ($[40] !== provinces || $[41] !== selectedParentId) {
      t10 = <ul className="w-130 shrink-0 overflow-y-auto bg-Gray-50">{[{
          homeLoveGovCodeId: null,
          value: ALL_TAB_LABEL
        }, ...(provinces ?? [])].map(t23 => {
          const {
            homeLoveGovCodeId: homeLoveGovCodeId_0,
            value
          } = t23;
          return <li key={homeLoveGovCodeId_0 ?? ALL_TAB_LABEL}><button aria-pressed={selectedParentId === homeLoveGovCodeId_0} className={cn("flex h-62 w-full items-center justify-center px-8 text-center font-700 typo-body4", FOCUS_RING, selectedParentId === homeLoveGovCodeId_0 ? "bg-O-400 text-Gray-white" : "text-Gray-900")} onClick={() => setSelectedParentId(homeLoveGovCodeId_0)}><span className="line-clamp-2">{value.trim()}</span></button></li>;
        })}</ul>;
      $[40] = provinces;
      $[41] = selectedParentId;
      $[42] = t10;
    } else {
      t10 = $[42];
    }
    t7 = "min-h-0 flex-1 overflow-y-auto bg-Gray-white";
    t8 = rows.length === 0 ? !isPending && <li className="h-92 text-Gray-600 flex-center typo-body4">조회된 지역이 없어요.</li> : rows.map(t23 => {
      const {
        key,
        label,
        id: id_0
      } = t23;
      return <li key={key} className="border-b border-Gray-200"><button className={cn("flex w-full items-center px-12 py-20 text-left font-600 text-Gray-900 typo-body4", FOCUS_RING, "transition-colors duration-150 active:bg-Gray-50 xl:hover:bg-Gray-50")} onClick={() => handleSelectRegion(id_0)}>{label}</button></li>;
    });
    $[11] = districts;
    $[12] = handleClose;
    $[13] = isPending;
    $[14] = opened;
    $[15] = provinces;
    $[16] = router;
    $[17] = searchKeyword;
    $[18] = selectedParentId;
    $[19] = T0;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
  } else {
    T0 = $[19];
    t10 = $[20];
    t11 = $[21];
    t12 = $[22];
    t13 = $[23];
    t14 = $[24];
    t15 = $[25];
    t16 = $[26];
    t17 = $[27];
    t18 = $[28];
    t7 = $[29];
    t8 = $[30];
    t9 = $[31];
  }
  let t19;
  if ($[43] !== t7 || $[44] !== t8) {
    t19 = <ul className={t7}>{t8}</ul>;
    $[43] = t7;
    $[44] = t8;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t10 || $[47] !== t19 || $[48] !== t9) {
    t20 = <div className={t9}>{t10}{t19}</div>;
    $[46] = t10;
    $[47] = t19;
    $[48] = t9;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== t11 || $[51] !== t12 || $[52] !== t20) {
    t21 = <div className={t11}>{t12}{t20}</div>;
    $[50] = t11;
    $[51] = t12;
    $[52] = t20;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] !== T0 || $[55] !== t13 || $[56] !== t14 || $[57] !== t15 || $[58] !== t16 || $[59] !== t17 || $[60] !== t18 || $[61] !== t21) {
    t22 = <T0 isAppBarHeader={t13} drawerNoPadding={t14} modalHeader={t15} opened={t16} onClose={t17} title={t18}>{t21}</T0>;
    $[54] = T0;
    $[55] = t13;
    $[56] = t14;
    $[57] = t15;
    $[58] = t16;
    $[59] = t17;
    $[60] = t18;
    $[61] = t21;
    $[62] = t22;
  } else {
    t22 = $[62];
  }
  return t22;
};
function _temp(data) {
  return data.context?.contents ?? [];
}
function _temp2(data_0) {
  return data_0.context?.contents ?? [];
}
function _temp3(t0) {
  const {
    homeLoveGovCodeId,
    fullName,
    institutionSlugId
  } = t0;
  return {
    key: homeLoveGovCodeId,
    label: fullName,
    id: institutionSlugId
  };
}